let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dYNme")).then(() => parcelRequire('k1b6w'));